import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import StopIfZeroForm from '../forms/stop-if-zero-form';
import { stopIfZeroValidationSchema } from '../schema/stopIfZero.js';

export default function StopIfZeroNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Stop If Zero Node Details',
        altText: 'Stop If Zero Node',
        defaultLabel: data?.command || 'Stop If Zero Node',
        forceDefaultLabel: true,
      }}
    >
      <CommonNode FormComponent={StopIfZeroForm} schemaResolver={stopIfZeroValidationSchema} />
    </NodeProvider>
  );
}
